/**
 * Pill con el status de un industry job (active/paused/ready/etc).
 * Color classes vienen de JOB_STATUS_BADGE en lib/industry.
 */

import { JOB_STATUS_BADGE, type JobStatus } from '../lib/industry'

export function IndustryStatusBadge({ status }: { status: JobStatus }) {
  return (
    <span
      className={`text-[10px] font-mono uppercase px-1.5 py-0.5 rounded border ${JOB_STATUS_BADGE[status]}`}
    >
      {status}
    </span>
  )
}
